module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_close-ebdb6038df3d3ea15dd1d501ac20a438.svg";